// extracted by mini-css-extract-plugin
export default {"text-body-1":"Header_text-body-1__Jh-zT","text-body-3":"Header_text-body-3__wNk2O","header":"Header_header__OKWO7","upDown":"Header_upDown__0s7LC"};